import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../pages/Homepage.css";
import Navbar from "../pages/Navbar";
import Footer from "../pages/Footer";
import aboutlap from "./Homepage/Images/aboutlap.svg";


const PrivacyandPolicy = () => {
  return (
    <div>
      <Navbar />
      <div className="about-banner">
        <h2>Privacy And Policy</h2>
        <p>
          Your privacy is important to us. This Privacy Policy explains how we collect, use, protect, and handle your personal information when you use our website and services. We are committed to safeguarding your data and ensuring transparency in our practices. By accessing or using our services, you agree to the collection and use of information in accordance with this policy. Please review this page regularly for updates or changes to our privacy practices.
        </p>
      </div>
     
      <div className="about-white-line">
        <div className="about-des container pt-5">
            <h3>Empowering Your Digital Journey</h3>
            <p>
              Our mission is to transform the way organizations and individuals leverage technology by providing smart, accessible, and secure digital tools. We streamline operations, enhance productivity, and foster innovation, helping our clients achieve their goals with confidence and clarity.
            </p>
            <ul>
              <li>Data privacy and security are our top priorities.</li>
              <li>We use industry-standard encryption to protect your information.</li>
              <li>Your personal data is never sold or shared without your consent.</li>
              <li>We are transparent about how your information is collected and used.</li>
              <li>Our team is committed to continuous improvement of our privacy practices.</li>
            </ul>
        </div>
        
        <div className="about-location py-5">
            <div className="about-des-location container mx-auto">
            <h3>Our Location</h3>
            <p>Shop No. 203 II Floor, Hiltan Arcade Shopping Center, Evershine CityGokhivare,  Vasai East, Vasai, Mumbai - 401208.</p>
            </div>
            
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyandPolicy;
